module.exports = __webpack_public_path__ + "assets/ad1d549a20325050d254fa3355b701ce.mp4";